export const ERROR_USER_EXISTS = 'USER_EXISTS'
